<template>
    <div>
        <Modulo :idCurso="idCurso" :moduloEdicao="modulo" :mostrar="abrirModulo" @fecharModulo="fechar()" @moduloCadastrado="AtualizarModulos($event)" @moduloAtualizado="AtualizarModulos($event)"/>
        <Excluir :modulo="modulo" :mostrar="abrirExcluir" @moduloExcluido="retirarModuloExcluido($event)" @fecharExcluir="fechar()"/>
        <v-card >
            
            <v-card-title><h3>Modulos</h3><v-spacer></v-spacer> <v-chip color="primary">Total: {{modulos != undefined ? modulos.length : 0}}</v-chip></v-card-title>
            <v-divider></v-divider>
            <v-card-text class="scroll" >
                <v-list>
                    <v-list-item v-for="mod in modulos" :key="mod.id">
                        <v-list-item-content>
                            <v-list-item-title><h3>{{mod.nome}}</h3></v-list-item-title>
                            <v-list-item-subtitle><v-chip x-small color="primary">{{quantidadeAulas(mod.aulas != undefined ? mod.aulas.length : 0)}}</v-chip></v-list-item-subtitle>
                        </v-list-item-content>
                        <template>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" small icon color="primary" @click="editarModulo(mod)"><v-icon>mdi-pencil</v-icon></v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </template>
                        <template>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" small icon color="primary" @click="excluirModulo(mod)"><v-icon>mdi-delete</v-icon></v-btn>
                                    </template>
                                    <span>Deletar</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="AbrirNovoModulo()">Novo Modulo</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import Modulo from '@/components/admin/cursos/Modulo'
import Excluir from '@/components/admin/cursos/ExcluirModulo'

export default {
    name:"Modulos",
    props:['idCurso', 'modulos'],
    components:{Modulo, Excluir},
    computed:{
        
    },
    data(){
        return{
            abrirModulo: false,
            modulo: {},
            abrirExcluir: false,
        }
    },
    methods:{
        AbrirNovoModulo(){
            this.abrirModulo = true
        },

        AtualizarModulos(modulo){
            this.$emit('atualizaModulos', modulo)
        },

        editarModulo(modulo){
            this.modulo = modulo
            this.abrirModulo = true
        },
        excluirModulo(modulo){
            this.modulo = modulo
            this.abrirExcluir = true
        },
        fechar(){
            this.abrirModulo = false
            this.abrirExcluir = false
            this.modulo = {id: 0}
        },
        quantidadeAulas(v){
            if(v == 0){
                return 'Nenhuma aula registrada'
            }else if(v == 1){
                return '1 aula registrada'
            }else{
                return v + ' aulas registradas'
            }
        },
        retirarModuloExcluido(id){
            this.$emit('excluirModulo', id)
            this.fechar()
        }
    }
}
</script>

<style scoped>
.scroll{
    overflow-y: scroll;
    max-height: 300px;
}
</style>